// extracted by mini-css-extract-plugin
export var hideEditor = "_l8-2";
export var infoIcon = "_l8-3";
export var label = "_l8-1";
export var labelContainer = "_l8-0";
export var readonlyText = "_l8-4";